import { serverFetch } from "../extensions/server";

export const userLoaded = (user) => ({
  type: "USER_LOADED",
  payload: user,
});

export const companyLoaded = (company) => ({
  type: "COMPANY_LOADED",
  payload: company,
});

export const companyLoadFailed = (error) => ({
  type: "COMPANY_LOAD_FAILED",
  payload: error,
});
